import { Box, Typography } from '@material-ui/core';
import { accessHistoryApi } from 'api/authApi';
import {
  getAvailableReservationForNewClientsBookingOnlineApi, getCMInfoApi, getDetailOnlineStoreApi, getHeadQuarterApi, getNeighborhoodStoresApi, getStoreSettingDetailApi,
} from 'api/onlineBookingV2Api';
import ScreenLoader from 'components/organismos/ScreenLoader';
import { getTextGender } from 'constants/reservation';
import moment from 'moment';
import useAppSnackbar from 'hooks/useAppSnackbar';
import BigButtonNext from 'pages/reservationBookingOnlineV2/components/BigButtonNext';
import DesiredStoreOptions from 'pages/reservationBookingOnlineV2/components/DesiredStoreOptions';
import TableCalender from 'pages/reservationBookingOnlineV2/components/TableCalender';
import { StatusBooking, useReservationBookingOnlineContext } from 'pages/reservationBookingOnlineV2/context';
import {
  formatDataAvailableReservation, formatSelectOptionList, getDateByReservationAcceptanceDeadline, returnHistoryPath,
} from 'pages/reservationBookingOnlineV2/functions';
import { stringify } from 'qs';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import handleError from 'utility/handleError';
import SectionHeader from '../../components/SectionHeader';
import { ISelectOption, TDetailOnlineStore } from '../StepsBeforeReservation/types';
import useStyles from './styles';
import {
  ICalenderBooking, ICMInfo, IDateBooking, IDateCalender, IHeadQuarterData, IReservationSearchBookingOnline, IStoreSettingDetail,
} from './types';

const NOW_DATE = moment();
const START_DATE = NOW_DATE.format('YYYY-MM-DD');
const END_DATE = moment(START_DATE).add(6, 'days').format('YYYY-MM-DD');
export interface IStepDateAndTimeVisitSelection {
  companyCode:string,
  courseCode?:string,
  mediaCode?:string,
  gender?:string,
  serviceCode?:string,
  trackingCode?:string,
}

const StepDateAndTimeVisitSelection : React.FC<IStepDateAndTimeVisitSelection> = ({
  companyCode, courseCode, mediaCode, gender, serviceCode, trackingCode,
}) => {
  const [isLoading, setLoading] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useAppSnackbar();
  const {
    handleChange, chosenDesiredService, chosenDesiredCare, chosenCourse, chosenArea, chosenStore, chosenStoreName, chosenCourseAcceptRequestReservation, handleDisplayDialog,
  } = useReservationBookingOnlineContext();
  const [headQuarterData, setHeadQuarterData] = useState<IHeadQuarterData>();
  const [detailOnlineStore, setDetailOnlineStore] = useState<TDetailOnlineStore>();
  const [cMInfoData, setCMInfoData] = useState<ICMInfo[]>([]);
  const [storeSetting, setStoreSetting] = useState<IStoreSettingDetail>();
  const [dateBooking, setDateBooking] = useState<IDateBooking>({ startDate: START_DATE, endDate: END_DATE });
  const [datesCalender, setDatesCalender] = useState<IDateCalender[]>([]);
  const [timesCalender, setTimesCalender] = useState<ICalenderBooking[][]>([]);
  const [desiredStoreList, setDesiredStoreList] = useState<ISelectOption[]>([]);
  const [selectTime, setSelectTime] = useState<ICalenderBooking | null>(null);
  // Call api get time booking
  const getAvailableReservationForNewClientsBookingOnline = useCallback(async (params:IReservationSearchBookingOnline) => {
    try {
      setLoading(true);
      const res = await getAvailableReservationForNewClientsBookingOnlineApi(params);
      const [arrTimeCalender, arrDateCalender] = formatDataAvailableReservation(res);
      setTimesCalender(arrTimeCalender);
      setDatesCalender(arrDateCalender);
    } catch (error: any) {
      handleError({ error, enqueueSnackbar });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  // ご希望の店舗
  const getNeighborhoodStoreList = useCallback(async (argument:{ companyCode:string, choosingOrgId: string, contractCourseMstId: string}) => {
    try {
      const res = await getNeighborhoodStoresApi(argument);
      setDesiredStoreList(formatSelectOptionList(res, 'orgId', 'orgName'));
    } catch (error: any) {
      handleError({ error, enqueueSnackbar });
    }
  }, [enqueueSnackbar]);

  // (設立許可書/経営企)
  const getHeadQuarter = useCallback(async (argument:string) => {
    try {
      const res = await getHeadQuarterApi(argument);
      setHeadQuarterData(res);
    } catch (error: any) {
      handleError({ error, enqueueSnackbar });
    }
  }, [enqueueSnackbar]);

  const getCMInfoCompany = useCallback(async (argument:string) => {
    try {
      const res = await getCMInfoApi(argument);
      setCMInfoData(res);
    } catch (error: any) {
      handleError({ error, enqueueSnackbar });
    }
  }, [enqueueSnackbar]);

  const getStoreSettingDetail = useCallback(async (argument:{ orgId: string, companyCode: string}) => {
    try {
      const res = await getStoreSettingDetailApi(argument);
      setStoreSetting({
        ...res,
        // 新規顧客用の設定が未登録なら既存顧客用にフォールバック（BE と同じ挙動）
        possibleMonthCode: res?.newCustomerPossibleMonthCode ?? res?.possibleMonthCode,
        reservationAcceptanceDeadline: res?.newCustomerReservationAcceptanceDeadline ?? res?.reservationAcceptanceDeadline,
      });
      setSelectTime(null);
    } catch (error: any) {
      handleError({ error, enqueueSnackbar });
    }
  }, [enqueueSnackbar]);

  const getDetailOnlineStore = useCallback(async (argument: { orgId: string, companyCode: string}) => {
    try {
      const res = await getDetailOnlineStoreApi(argument);
      setDetailOnlineStore(res);
    } catch (error: any) {
      handleError({ error, enqueueSnackbar });
    }
  }, [enqueueSnackbar]);

  // handle change store
  const handleClickStoreOption = useCallback((storeId:string, storeName:string) => {
    handleChange({ name: 'chosenStore', value: storeId });
    handleChange({ name: 'chosenStoreName', value: storeName });
  }, [handleChange]);

  const handleChangePrevWeek = useCallback(() => {
    setDateBooking((prevState) => ({
      startDate: moment(prevState?.startDate).subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: moment(prevState?.startDate).subtract(1, 'days').format('YYYY-MM-DD'),
    }));
    setSelectTime(null);
  }, []);

  const handleChangeNextWeek = useCallback(() => {
    setDateBooking((prevState) => ({
      startDate: moment(prevState?.endDate).add(1, 'days').format('YYYY-MM-DD'),
      endDate: moment(prevState?.endDate).add(7, 'days').format('YYYY-MM-DD'),
    }));
    setSelectTime(null);
  }, []);

  const handleChangeSelectTime = useCallback((item) => {
    setSelectTime(item);
  }, []);

  const handleChangeSelectDate = (date:string) => {
    setDateBooking((prevState) => ({
      startDate: moment(date).subtract(3, 'days').format('YYYY-MM-DD'), // when use select day in calender of button カレンダーから日付を選択, value  will is column 4th in calender
      endDate: moment(date).add(3, 'days').format('YYYY-MM-DD'), // when use select day in calender of button カレンダーから日付を選択, value  will is column 4th in calender
    }));
  };


  const handleSubmit = () => {
    if (!selectTime?.date || !selectTime?.time) {
      return;
    }
    handleChange({ name: 'desiredTime', value: `${moment(selectTime?.date || '').format('YYYY年MM月DD日')} ${selectTime?.time || ''}` });
    handleChange({ name: 'status', value: selectTime?.status });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'reservation_datetime_selected',
      reservation_company_code: companyCode,
      reservation_org_id: chosenStore || '',
      reservation_org_name: chosenStoreName || '',
      reservation_date: moment(selectTime?.date || '').format('YYYY-MM-DD'),
      reservation_time: selectTime?.time || '',
      reservation_status: selectTime?.status || '',
    });
    history.replace({
      search: returnHistoryPath(companyCode, 3, courseCode, mediaCode, gender, serviceCode, trackingCode),
    });
  };

  useEffect(() => {
    // Check accept page
    if (!chosenDesiredService || !chosenDesiredCare || !chosenCourse || !chosenArea || !chosenStore) {
      enqueueSnackbar('セッションが切れましたので、再度サービスを選択してください', { variant: 'error' });
      history.replace({
        search: returnHistoryPath(companyCode, 0, courseCode, mediaCode, gender, serviceCode, trackingCode),
      });
    }
    // Save history access screen
    try {
      const paramsPost = { accessUrl: `${history?.location?.pathname + history?.location?.search}`, companyCode, staffId: '' };
      accessHistoryApi(paramsPost);
    } catch (error) {
      handleError({ error, enqueueSnackbar });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Cm Info
    if (!companyCode) return;
    getCMInfoCompany(companyCode);
  }, [companyCode, getCMInfoCompany]);

  useEffect(() => {
    // Store Setting Detail
    if (!companyCode || !chosenStore) return;
    Promise.all([getStoreSettingDetail({ companyCode, orgId: chosenStore }), getDetailOnlineStore({ companyCode, orgId: chosenStore })]);
  }, [companyCode, chosenStore, getStoreSettingDetail, getDetailOnlineStore]);


  useEffect(() => {
    // ご希望の店舗
    if (!companyCode || !chosenStore) return;
    getNeighborhoodStoreList({
      companyCode,
      choosingOrgId: chosenStore,
      contractCourseMstId: chosenCourse,
    });
  }, [chosenStore, companyCode, getNeighborhoodStoreList, chosenCourse]);


  useEffect(() => {
    // code here
    if (companyCode && chosenDesiredService && chosenDesiredCare && chosenCourse && chosenArea && chosenStore && dateBooking.startDate && dateBooking.endDate) {
      const params = {
        companyCode,
        startDate: dateBooking?.startDate,
        endDate: dateBooking?.endDate,
        classType: getTextGender(chosenDesiredService),
        contractCourseCategoryId: chosenDesiredCare,
        contractCourseId: chosenCourse,
        areaId: chosenArea,
        orgId: chosenStore,
      };
      getAvailableReservationForNewClientsBookingOnline(params);
    }
  }, [chosenDesiredService, chosenDesiredCare, chosenCourse, chosenArea, chosenStore, companyCode, getAvailableReservationForNewClientsBookingOnline, dateBooking.startDate, dateBooking.endDate]);


  return (
    <ScreenLoader isLoading={isLoading}>
      {/* Steps before reservation */}
      <div className={classes.root}>
        <SectionHeader title={chosenCourseAcceptRequestReservation ? '2. ご来店希望日時を選択してください' : '2. ご来店日時を選択'} />
        <div>
          <TableCalender
            storeSetting={storeSetting}
            storeName={chosenStoreName}
            timesCalender={timesCalender}
            dateBooking={dateBooking}
            datesCalender={datesCalender}
            handleChangePrevWeek={handleChangePrevWeek}
            handleChangeNextWeek={handleChangeNextWeek}
            handleChangeSelectTime={handleChangeSelectTime}
            handleChangeSelectDate={handleChangeSelectDate}
            nonBookableNote="△マークをタップして希望店舗へお問い合わせください。店舗より折り返しご連絡いたします。"
          />
        </div>
        <Box>
          <h4 className={classes.box_belt}>近隣のサロンの予約状況を見る</h4>
        </Box>
        {/* Store of your choice */}
        <Box className={classes.serviceItem}>
          <DesiredStoreOptions title="" list={desiredStoreList} defaultOption={chosenStore} handleClick={handleClickStoreOption} isRequired={true} />
        </Box>
        {/* Button  */}
        <div className={classes.buttonContainer}>
          { selectTime && (<BigButtonNext content={selectTime?.status === StatusBooking.AVAILABLE_BOOKING ? 'お客様情報の入力へ' : 'お問い合わせフォームへ'} handleSubmit={handleSubmit} />) }
        </div>
      </div>
    </ScreenLoader>
  );
};

export default StepDateAndTimeVisitSelection;
